import { AxiosInstance } from 'axios';
import { IAcceptInvitation, IContactSupportPayload, ICreateUser, IUserMe, IUserOrganization } from '../models/User';
import { BaseHTTP } from './base.http'


class UserApi {

  private http !: AxiosInstance

  constructor() {
    this.http = BaseHTTP.getInstance().http
  }

  getAll() {
    return this.http.get<IUserOrganization[]>('v1/users/all')
  }

  getMe() {
    return this.http.get<IUserMe>('v1/users/me')
  }

  createUser(userPayload: ICreateUser) {
    return this.http.post<{ token: string }>('v1/auth/register', userPayload)
  }

  acceptInvitation(acceptInvitation: IAcceptInvitation) {
    return this.http.post<{ token: string }>('v1/auth/invitations', acceptInvitation)
  }

  existsByEmail(email: string) {
    return this.http.get<boolean>('v1/users/exists', { params: { email } })
  }

  createAdminPanelHandoff() {
    return this.http.post<{ entryUrl: string }>('v1/auth/admin-panel-handoff')
  }

  signIn(firebaseToken: string) {
    return this.http.post<{ token: string }>('v1/auth/login', { token: firebaseToken })
  }
  
  updateUserMeExtra(data: Record<string, any>) {
    return this.http.patch<{ extra: Record<string, unknown> }>(
      'v1/users/me/extra',
      data
    )
  }

  downloadUsersBusinessesReport() {
    return this.http.get('v1/reports/users-businesses', {
      params: { format: 'xlsx' },
      responseType: 'blob',
    })
  }

  contactSupport(organizationId: number, payload: IContactSupportPayload) {
    return this.http.post<{ ok: boolean; score: number | null }>(
      `v1/business/${organizationId}/support/contact`,
      payload,
    )
  }
}

export default new UserApi();
